import { EVENT_COLUMN_LIMITS } from "./eventColumnLimits";

/**
 * CMS `route` is free text with no validation, so it arrives with or without a
 * leading slash and sometimes a trailing one. useReportTitle and
 * ReportTelemetry must match on exactly the same rule — two near-identical
 * matchers is how the download series and the report-opened series drift
 * apart.
 */
export const normalizeRoute = (route?: string): string => {
  const trimmed = (route ?? "").trim().replace(/\/+$/, "");
  if (!trimmed) return "";
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
};

/**
 * The `what_id` for a report event: `REPORT-<route slug>`, e.g.
 * `REPORT-ms-usage-report` for `/reports/ms-usage-report`.
 *
 * Keyed on the route, not the CMS name. The name went in `result` before and
 * was the row that broke the 2026-10-29 ingest batch: `result` is VARCHAR(20)
 * and "Career Planning Progress" is 24. `what_id` is VARCHAR(64), and a route
 * is stable across a rename where a name is not. The name still travels in
 * metadata for anyone reading the raw table.
 *
 * Only the part after `/reports/` is kept, with `/` folded to `-`, so a detail
 * page that was not matched to its parent CMS report still yields a readable
 * key (`REPORT-ms-usage-report-school-<id>`), truncated to the column.
 */
export const reportWhatId = (route: string): string => {
  const slug = normalizeRoute(route)
    .replace(/^\/reports\//, "")
    .replace(/^\//, "")
    .replace(/\//g, "-");
  return `REPORT-${slug || "unknown"}`.slice(0, EVENT_COLUMN_LIMITS.what_id);
};
